import CatalogMenu from "./CatalogMenu";
import BasicMenu from "./BasicMenu";
import CitySelect from "./CitySelect";
import Navigation from "./Navigation";
import {useContext, useEffect, useState} from "react";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getTopCategories} from "../../../api/catalog";
import {Link, useLocation, useNavigate} from "react-router-dom";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import SearchString from "./SearchString";
import {ReducerStateInterface} from "../../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../../GlobalReducer";
import Auth from "../../customer/Auth";
import HeaderProgressBar from "../HeaderProgressBar"; // если нужно стили подключить


export default function Header() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const location = useLocation();
    const navigate = useNavigate();

    const [isAuthOpen, setIsAuthOpen] = useState(false)

    useEffect(() => {
        setIsMenuOpen(false)
        // Your tracking logic here
    }, [location]);

    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);

    const {data, status} = useQuery({
        queryKey: ['top-categories'],
        queryFn: () => getTopCategories(),
        placeholderData: keepPreviousData
    })

    const closeAuth = () => {
        setIsAuthOpen(false)
    }

    const closeMenu = () => {
        setIsMenuOpen(false)
    }

    const totalQuantityInBasket = state.basket ? state.basket.reduce((sum, item) => sum + item.quantity, 0) : 0;

    return (<header className={'header ' + (isMenuOpen && 'menu-catalog-open menu-open')}>
        {isAuthOpen && <Auth close={closeAuth}/>}
        <div className="container">
            <div className="d-flex header__body">

                <div className="w-100 header__content">
                    <div className="align-items-center gap-2 d-lg-flex d-none header__top w-100">
                        <CitySelect/>
                        <Navigation/>
                    </div>
                    <div className="d-flex align-items-center header__bottom">
                        <a href="/" className="header__logo logo">
                            <img src="/images/logo.svg" alt=""/>
                        </a>
                        <div onClick={() => {
                            setIsMenuOpen(!isMenuOpen);
                        }}
                             className="btn btn-primary d-lg-flex d-none header__btn-catalog icon-menu icon-menu-catalog">
                            <span>Каталог</span>
                        </div>

                        {/*<AsyncTypeahead*/}
                        {/*    isLoading={isLoading}*/}
                        {/*    className={'d-flex header__search w-md-auto ' + (isSearchOpen && '_open')}*/}
                        {/*    placeholder={'Поиск по пользователям GitHub'}*/}
                        {/*    // @ts-ignore*/}
                        {/*    labelKey={(option) => option.login} // теперь TS знает что есть login*/}
                        {/*    onSearch={(query) => {*/}
                        {/*        setIsLoading(true);*/}
                        {/*        fetch(`https://api.github.com/search/users?q=${query}`)*/}
                        {/*            .then(resp => resp.json())*/}
                        {/*            .then(json => {*/}
                        {/*                setOptions(json.items || []);*/}
                        {/*                setIsLoading(false);*/}
                        {/*            });*/}
                        {/*    }}*/}
                        {/*    options={options}*/}
                        {/*/>*/}


                        <SearchString isSearchOpen={isSearchOpen}/>

                        <div className="d-flex ms-auto d-md-none header__btn-big header__search-open search-open">
                            <img src="/images/icon-h-serch.svg" alt="" onClick={() => setIsSearchOpen(!isSearchOpen)}/>
                        </div>
                        <Link to={'/comparison'} className="header__btn-big stroke d-lg-flex d-none">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.8301 9.90918V14.9316H12.5566V9.90918H14.8301ZM9.33301 1.66406V14.9316H7.05957V1.66406H9.33301ZM3.83594 6.24512V14.9316H1.5625V6.24512H3.83594Z"
                                    stroke="#292929" strokeWidth="1.39118"/>
                            </svg>
                            <span>Сравнение {state.comparison && state.comparison.length > 0 &&
                                <span className={'btn-label'}>{state.comparison.length}</span>}</span>
                        </Link>
                        <Link to={'/favorites'} className="header__btn-big fill">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.6969 15.9494L7.48767 14.8653C6.08386 13.6005 4.92329 12.5094 4.00594 11.592C3.0886 10.6747 2.3589 9.85104 1.81683 9.12106C1.27476 8.39108 0.896152 7.72058 0.680994 7.10958C0.465835 6.49857 0.357978 5.87311 0.357422 5.2332C0.357422 3.92668 0.795244 2.8356 1.67089 1.95995C2.54653 1.08431 3.63762 0.646484 4.94413 0.646484C5.66689 0.646484 6.3549 0.799375 7.00815 1.10516C7.66141 1.41094 8.22433 1.84181 8.6969 2.39777C9.16947 1.84181 9.73238 1.41094 10.3856 1.10516C11.0389 0.799375 11.7269 0.646484 12.4497 0.646484C13.7562 0.646484 14.8473 1.08431 15.7229 1.95995C16.5986 2.8356 17.0364 3.92668 17.0364 5.2332C17.0364 5.87256 16.9288 6.49802 16.7136 7.10958C16.4985 7.72114 16.1196 8.39163 15.577 9.12106C15.0343 9.85049 14.3046 10.6741 13.3879 11.592C12.4711 12.5099 11.3105 13.601 9.90612 14.8653L8.6969 15.9494ZM8.6969 13.6978C10.0312 12.5024 11.1292 11.4775 11.991 10.623C12.8527 9.76848 13.5338 9.02488 14.0342 8.39219C14.5345 7.7595 14.882 7.19631 15.0766 6.70261C15.2712 6.20891 15.3685 5.71911 15.3685 5.2332C15.3685 4.39925 15.0905 3.70429 14.5345 3.14833C13.9786 2.59236 13.2836 2.31438 12.4497 2.31438C11.7964 2.31438 11.1918 2.4984 10.6358 2.86645C10.0799 3.2345 9.69764 3.70374 9.48915 4.27416H7.90465C7.69616 3.70429 7.31394 3.23534 6.75797 2.86729C6.20201 2.49924 5.59739 2.31494 4.94413 2.31438C4.11019 2.31438 3.41523 2.59236 2.85926 3.14833C2.3033 3.70429 2.02532 4.39925 2.02532 5.2332C2.02532 5.71967 2.12261 6.20975 2.3172 6.70345C2.51179 7.19714 2.85926 7.76006 3.35963 8.39219C3.86 9.02432 4.54106 9.76793 5.40281 10.623C6.26455 11.4781 7.36258 12.503 8.6969 13.6978Z"
                                    fill="#292929"/>
                            </svg>
                            <span>Избранное {state.favorites && state.favorites.length > 0 &&
                                <span className={'btn-label'}>{state.favorites.length}</span>}</span>
                        </Link>
                        <Link to={'/basket'} className="header__btn-big stroke">
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2022_7877)">
                                    <path d="M0.949219 15.2845L1.91165 3.97363H11.144L12.4273 15.2845H0.949219Z"
                                          stroke="#292929" strokeWidth="1.39118"/>
                                    <path
                                        d="M8.63407 3.30756C8.63407 2.20518 7.76724 1.31152 6.69789 1.31152C5.62858 1.31152 4.76172 2.20518 4.76172 3.30756"
                                        stroke="#292929" strokeWidth="1.39118"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_2022_7877">
                                        <rect width="12.9078" height="15.3029" fill="white"
                                              transform="translate(0.244141 0.646484)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span>Корзина {totalQuantityInBasket > 0 &&
                                <span className={'btn-label'}>{totalQuantityInBasket}</span>}</span>
                        </Link>
                        <span className="header__btn-big stroke pointer" onClick={() => {
                            if(state.customer && state.customer.id){
                                navigate('/account/profile')
                                return
                            }else{
                                // не авторизован - открыть окно авторизации
                                setIsAuthOpen(true)
                            }
                        }}>
                            <svg width="13" height="16" viewBox="0 0 13 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2022_7882)">
                                    <path
                                        d="M6.4478 6.66453C7.88166 6.66453 9.04403 5.46622 9.04403 3.98803C9.04403 2.50984 7.88166 1.31152 6.4478 1.31152C5.01394 1.31152 3.85156 2.50984 3.85156 3.98803C3.85156 5.46622 5.01394 6.66453 6.4478 6.66453Z"
                                        stroke="#292929" strokeWidth="1.39118"/>
                                    <path
                                        d="M12.1826 15.8128V14.5275C12.1826 11.4041 9.72649 8.87207 6.69676 8.87207C3.66703 8.87207 1.21094 11.4041 1.21094 14.5275V15.8128"
                                        stroke="#292929" strokeWidth="1.39118"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_2022_7882">
                                        <rect width="12.2624" height="15.3029" fill="white"
                                              transform="translate(0.566406 0.646484)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span>Профиль</span>
                        </span>
                        <div className="header__btn-big header__burger icon-menu icon-menu-basic"
                             onClick={() => {
                                 if(state.customer && state.customer.id){
                                     navigate('/account/profile')
                                     return
                                 }else{
                                     // не авторизован - открыть окно авторизации
                                     setIsAuthOpen(true)
                                 }
                             }}>
                            <img src="/images/icon-menu-open.svg" alt=""/>
                        </div>
                    </div>
                </div>
            </div>

            {state.error && <div className={"modal show"} onClick={() => {
                dispatch({type: ReducerActionType.ERROR, payload: null});
            }}>
                <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                    <div className="d-flex flex-column modal-content">
                        <div className="d-flex flex-column modal-box modal-header">
                            <button type="button" className="btn-close"
                                    aria-label="Закрыть" onClick={() => {
                                dispatch({type: ReducerActionType.ERROR, payload: null});
                            }}></button>
                            <div className="fw-bold modal-title" id="modalVerticallyCenteredLabel">Ошибка</div>
                        </div>
                        <div className="d-flex flex-column modal-box modal-body">
                            <div className="alert alert-danger" role="alert">
                                {state.error.message}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}


        </div>

        <BasicMenu/>
        <CatalogMenu categories={data?.categories || []} closeMenu={closeMenu}/>


    </header>)

}